export const ADD_USER_PAYOUT_CONDITIONS = "ADD_USER_PAYOUT_CONDITIONS";
export const GET_USER_PAYOUT_CONDITIONS = "GET_USER_PAYOUT_CONDITIONS";
export const SET_USER_PAYOUT_CONDITIONS = "SET_USER_PAYOUT_CONDITIONS";
export const DELETE_USER_PAYOUT_CONDITIONS = "DELETE_USER_PAYOUT_CONDITIONS";
export const UPDATE_USER_PAYOUT_CONDITIONS = "UPDATE_USER_PAYOUT_CONDITIONS";

export const LOADER_USER_PAYOUT_CONDITIONS = "LOADER_USER_PAYOUT_CONDITIONS";